// extracted by mini-css-extract-plugin
export var darkMode = "_15-0";